import Axios from '@/store/axios'
var Promise = require('bluebird')

  const initialState = () => ({
    invoices: null
  });

  const state = initialState();
  const getters = {
    // GETTER returns a function which allows us to pass a parameter
    getInvoiceById: (state) => (id) => {
      return state.invoices.find( (invoice) => invoice.id === id)
    }
  }
  const mutations = {
    SET_INVOICES : (state, invoice_array) => {
      state.invoices = invoice_array;
    },
    UPDATE_INVOICE : (state, invoice) => {
      var index = state.invoices.findIndex( current_invoice => current_invoice.id === invoice.id);
      Object.assign(state.invoices[index], invoice);
    },
    RESET: (state) => {
      const newState = initialState();
      Object.keys(newState).forEach( key => {
        state[key] = newState[key]
      });
    }
  }
  const actions = {
    GET_INVOICE : ( context, id ) => {
      return Promise.try( () => {
        return Axios.get(`billing/invoices/${id}`)
      }).then( (invoice) => {
        context.commit('UPDATE_INVOICE', invoice.data);
        return
      })
    },
    GET_INVOICES : ( context ) => {
      return Promise.try( () => {
        return Axios.get(`billing/invoices`)
      }).then( (invoice_array) => {
        if(invoice_array.data.length > 0) {
          const new_invoice_array = invoice_array.data.map( invoice => ( {...invoice, date_due: invoice.date_due.slice(0, 10) })); // slice out time on date due - who gives a shit
          const reversed_array = new_invoice_array.reverse();
          context.commit('SET_INVOICES', reversed_array);
        } else {
          context.commit('SET_INVOICES', null);
        }
        return
      })
    }
  }

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
